export const ADMIN_AUTHOR_LABEL = 'Admin';

type AuthorLike = { name?: string; role?: string } | null | undefined;

export function getNoteAuthorLabel(author: AuthorLike, fallback = 'Anonim'): string {
  if (!author) return fallback;
  if (author.role === 'admin') return ADMIN_AUTHOR_LABEL;
  return author.name || fallback;
}
